import React from "react";

export default function Home(){
  return(
    <main className='home-main' >
      <div className="home-main_content-div">
        <h1 className="home-main_content-div_header">SO, YOU WANT TO TRAVEL TO</h1>
        <h2 className="home-main_content-div_sub-header">Space</h2>
        <p className="home-main_content-div_para"> Let’s face it; if you want to go to space, you might as well genuinely go to outer space and not hover kind of on the edge of it. Well sit back, and relax because we’ll give you a truly out of this world experience!</p>
      </div>
      <div className="home-main_logo-div">
        <h2 className="home-main_logo-div_header">Explore</h2>
      </div>
    </main>
  )
}